import { cmsAxiosInstance } from 'api/axiosClient'
import { withAuth } from 'hocs/withAuth'
import { withAuthServerSideProps } from 'hocs/withAuth/withAuthServerSideProps'
import { GetStaticPaths } from 'next'
import dynamic from 'next/dynamic'

const BlogDetailPage = dynamic(() =>
  import('containers/BlogDetailPage').then((res) => res.BlogDetailPage)
)

export default withAuth(BlogDetailPage, {
  LoggedOutComponent: BlogDetailPage,
  naiveCheck: true,
})

const getBlogDetails = async (context) => {
  const pid = context.params.pid
  try {
    const [blogDetailsRes, recentArticlesRes] = await Promise.all([
      cmsAxiosInstance.get(`/articles?filters[slug]=${pid}&populate=image_url`),
      cmsAxiosInstance.get('articles?populate=image_url'),
    ])

    const blog = blogDetailsRes?.data?.data?.[0]?.attributes || null
    const recentArticles =
      recentArticlesRes?.data?.data?.map(({ attributes }) => attributes) || null

    if (!blog || !recentArticles) {
      return {
        redirect: {
          destination: '/library',
          permanent: false,
        },
      }
    }

    return {
      blogDetails: blog,
      recentArticles,
    }
  } catch (e) {
    console.error('Error fetching article: ', e)
    return { notFound: true }
  }
}

export const getStaticProps = withAuthServerSideProps(getBlogDetails)

export const getStaticPaths: GetStaticPaths = async () => {
  const articles = (
    await cmsAxiosInstance.get('articles').catch((e) => {
      console.error(e)
      return { data: [] }
    })
  ).data

  return {
    paths:
      articles.data?.map(({ attributes }) => ({
        params: { pid: attributes.slug },
      })) || [],
    fallback: true,
  }
}
